// Hands a freshly-captured photo from the bottom-nav camera tap to the capture
// page across client navigation — a File can't ride in the URL, and iOS only
// opens the camera from a direct user gesture (so it must fire on the tap, not
// in a useEffect after the route changes).
let pending: File | null = null;

export function setPendingCapture(file: File): void {
  pending = file;
}

export function takePendingCapture(): File | null {
  const file = pending;
  pending = null;
  return file;
}
